import script from "./SummerNoteDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./SummerNoteDisplay.vue?vue&type=script&setup=true&lang=js"

import "./SummerNoteDisplay.vue?vue&type=style&index=0&id=60fbf971&lang=css"

const __exports__ = script;

export default __exports__